/**
  * 
  * @param {审核签名记录下载} params 
  * @returns 
  */

 import { requestPostFile, requestPost, requestGet, requestPostRes, requestGetRes, requestPatchRes } from '../EdcService';

 const urlPrefix = "/data";

 // 审核签名下载记录列表
 export const approveTaskList = (params) => {
    const url = `${urlPrefix}/approve/download/approveTaskList`;
    return requestPostRes(url, params)
};

// 项目枚举
export const approveProjectEnume = (params) => {
    const url = `${urlPrefix}/singleAudit/projectList`;
    return requestPostRes(url, params)
};

// 获取下载链接
export const downloadTaskUrl = (params) => {
    const url = `${urlPrefix}/approve/download/taskUrl`;
    return requestPostRes(url, params)
};

// 创建下载任务 
export const createDownloadTask = (params) => {
    const url = `${urlPrefix}/approve/download/createSingleAuditDataTask`;
    return requestPostRes(url, params)
};

